instant.educationPageClassesList = {
  showMoreClasses: function (element) {
    var tableWrapper = element.parentNode.parentNode;
    tableWrapper.style.height = tableWrapper.querySelector('table').clientHeight + 'px';
    
    // remove show more overlay
    element.parentNode.remove();
  
    // enable sticky table header, it breaks because of overflow-y-hidden
    tableWrapper.classList.remove('overflow-y-hidden');
    tableWrapper.querySelector('thead tr').classList.add('sticky')
  }
};